import { render, staticRenderFns } from "./licensePlatePopup.vue?vue&type=template&id=8f292546&scoped=true"
import script from "./licensePlatePopup.vue?vue&type=script&lang=js"
export * from "./licensePlatePopup.vue?vue&type=script&lang=js"
import style0 from "./licensePlatePopup.vue?vue&type=style&index=0&id=8f292546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f292546",
  null
  
)

export default component.exports